import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { WebTemplateNodeData } from "../node-types";
import { PanelWebTemplate } from "./panel-web-template";

export function TrackingPageActionNodePanel(
  props: NodePanelProps<WebTemplateNodeData>,
) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelWebTemplate />
    </PanelContainer>
  );
}
